import type { ReactNode } from 'react';
import Link from 'next/link';

import { isAbsoluteStorefrontHref } from '@/common/utils/tenant-href.utility';

interface StorefrontLinkProps {
  href: string;
  className?: string;
  'aria-label'?: string;
  children: ReactNode;
}

/**
 * Relative Witro paths stay on Next.js client routing.
 * Absolute tenant domains use a plain anchor so navigation leaves witro.shop.
 */
export default function StorefrontLink({
  href,
  className,
  children,
  ...rest
}: StorefrontLinkProps) {
  if (isAbsoluteStorefrontHref(href)) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} className={className} {...rest}>
      {children}
    </Link>
  );
}
